import { Outlet } from "react-router-dom";
import Header from "./Header";
import { useLanguage } from "@/contexts/LanguageContext";

const Layout = () => {
  const { t, language } = useLanguage();

  // Generate the correct URL based on the current language
  const getLegalUrl = () => {
    return language === "de"
      ? "https://www.silvaconsult.ch/de/legal"
      : "https://www.silvaconsult.ch/legal";
  };

  return (
    <div className="flex min-h-screen flex-col bg-white">
      <Header />
      <main className="flex-1 bg-slate-50">
        <Outlet />
      </main>
      <footer className="bg-slate-900 text-white py-6 px-4 text-sm">
        <div className="container mx-auto max-w-6xl">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p>
              © {new Date().getFullYear()} Silvaconsult Registry.{" "}
              {t("footer.allRightsReserved")}
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a
                href={getLegalUrl()}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:underline"
              >
                {t("footer.privacy")}
              </a>
              <a
                href={getLegalUrl()}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:underline"
              >
                {t("footer.terms")}
              </a>
              <a
                href={getLegalUrl()}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:underline"
              >
                {t("footer.contact")}
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
